<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<main-content :title="page.title || page.header" :content="page.content" :booking-id="page.bookingID" />

		<section class="main-content contact-section background-color">
			<div class="row contact-form-row">
				<div class="columns column6 contact-form-col">
					<contact-form name="meetingform" :form="form" />
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('meetingform', {
	query: { language: locale.value },
	key: `${locale.value}/meetingform`,
});
</script>

<style scoped lang="scss">
.mx-datepicker {
	width: 100%;
}

:deep(.mx-input) {
	border: none;
	height: auto;
	font-size: unset;
	color: unset;
	padding: 19px;
	margin: 10px 0 25px;

	&:focus,
	&:hover {
		border-color: transparent;
	}

	&:focus {
		outline: revert;
	}
}

.request-form {
	float: none;
	width: 100%;
	max-width: 700px;
	margin: 50px 0 25px;
	text-align: left;
}

.request-form > label {
	width: 100%;
	float: left;
	font-weight: 600;
}

.request-form input:not(.button),
.request-form textarea,
.request-form select {
	border: none;
	margin: 10px 0 25px;
	padding: 20px;
	background: #fff;
	width: 100%;
}

.request-form .checkboxes-container {
	overflow: auto;
	margin: 5px 0 15px;
}

.request-form .checkboxes,
.request-form .radiobuttons {
	width: 100%;
	float: left;
	margin: 5px 0;
}

.request-form .checkboxes.ntb {
	margin-top: -15px;
}

.request-form .checkboxes div,
.request-form .radiobuttons div {
	float: left;
	width: 100%;
	margin: 5px 0;
}

.request-form .checkboxes input:not(.extra-option),
.request-form .radiobuttons input {
	width: auto;
	float: left;
	background: none;
	border: none;
	box-shadow: none;
	margin: 5px 5px 5px 0;
	height: auto;
}

.request-form .checkboxes input:disabled,
.request-form .form-datepicker:disabled {
	background: #efefef;
	color: #ccc;
}

.request-form .checkboxes label,
.request-form .radiobuttons label {
	float: left;
}

.request-form .checkboxes .sub-label label {
	text-decoration: underline;
}

.request-form textarea {
	min-height: 100px;
}

.request-form input.button {
	width: auto;
	padding: 25px 35px;
	cursor: pointer;
}

@media (max-width: 400px) {
	.request-form .checkboxes .extra-option {
		margin: 10px 0 0;
		width: 100%;
	}
}
</style>
